import { SetupIntent } from '@stripe/stripe-js';

import { api_create_setup_intent_path } from '../../routes';
import request from './request';

interface SetupIntentParams {
  stripe_customer_id: string;
}

export const createSetupIntent = async (params: SetupIntentParams): Promise<SetupIntent> => {
  const response = await request('post', api_create_setup_intent_path(params));
  return response;
};
